<template>
  <div class="email-right-aside bookmark-tabcontent form theme-form datepicker-responsive">
    <div class="card email-body radius-left" id="productbox">
      <div class="">
        <b-overlay :show="loading" rounded="sm" :style="loading ? 'height:100vh;overflow:hidden;' : ''">
          <div class="tab-content">
            <div class="tab-pane fade" v-bind:class="'active show'">
              <div class="card">
                <div class="card-header d-flex customStickyCardHeader">
                  <h6 class="mb-0" style="align-self: center">
                    {{
                      this.langid == "1252"
                      ? form.productnameEng
                        ? form.productnameEng
                        : $t("lbl_EMPBE_NewProduct")
                      : form.productnameChi
                        ? form.productnameChi
                        : $t("lbl_EMPBE_NewProduct")
                    }}
                  </h6>
                  <div :style="fromAdmin ? '' : 'margin-right: 130px'">
                    <span class="f-12">
                      {{ $t("lbl_EMPBE_LastUpdate") }}:{{ saveupdatedDate }}<br />
                      {{ $t("lbl_EMPBE_LastSubmit") }}:{{ lastSubmitDate }}<br />
                      <!-- {{ $t("lbl_EMPBE_LastThreeMonthUpdateCount") }}:
                      {{ lastThreeMonthSubmitCount }} -->
                    </span>
                  </div>
                </div>
                <!-- {{ this.ProductId }}  --   {{ this.form.productId }} -->
                <div class="card-body">
                  <ValidationObserver ref="observer" v-slot="{ handleSubmit }">
                    <div class="ribbon ribbon-bookmark ribbon-right ribbon-success customRibbon" v-if="lastSubmitDate != '-'
                      ">
                      {{ $t("lbl_EMPBE_isActivate") }}
                    </div>
                    <div class="ribbon ribbon-bookmark ribbon-right ribbon-secondary customRibbon" v-else>
                      {{ $t("lbl_EMPBE_Draft") }}
                    </div>
                    <div class="row">


                      <div class="col-6 mt-auto">
                        <switchIput :title="$t('lbl_EMPBE_MainProd')" data-item="isMainProduct"
                          v-if="user.memberCode != 'FREE'" v-model="form.isMainProduct">
                        </switchIput>
                      </div>

                      <div class="col-6 d-flex" v-if="false">
                        <div class="ml-auto">
                          <div class="QRCodeContainer">
                            <b-spinner v-if="IsPending" label="Spinning"></b-spinner>
                            <img :src="QRCodeOSSURL">
                          </div>
                        </div>
                      </div>

                      <div class="col-6" v-if="false">
                        <switchIput :title="form.isLaunch ? $t('lbl_EMPBE_isActivate') : $t('lbl_EMPBE_NotActivate')"
                          data-item="isLaunch" v-model="form.isLaunch">
                        </switchIput>
                      </div>
                    </div>

                    <h5 v-b-toggle.divbasicInfo class="mb-3 font-info">
                      <i class="icofont icofont-caret-right" v-if="!divbasicInfoVisible"></i>
                      <i class="icofont icofont-caret-down" v-if="divbasicInfoVisible"></i>
                      {{ $t("lbl_EMPBE_ProductBasicInfo") }}
                    </h5>
                    <b-collapse id="divbasicInfo" class="col-12" v-model="divbasicInfoVisible">
                      <div class="row">
                        <div class="col-12 mb-3">
                          <h6>
                            {{ $t("Lbl_ProductName") }} <span class="text-danger">*</span>
                          </h6>
                        </div>
                      </div>
                      <div class="row">
                        <div class="col">
                          <textbox ControlId="ProductNameEn" :mandatory="$t('lbl_EMPBE_ProductNameEn') + $t('lbl_IsRequire')
                            " name="productnameEng" :title="$t('lbl_EMPBE_ProductNameEn')" data-item="productnameEng"
                            v-model="form.productnameEng" CharLimit="CheckEnglishChar">
                          </textbox>
                        </div>
                      </div>
                      <div class="row">
                        <div class="col">
                          <textbox ControlId="ProductNameCn" name="productnameChi" :mandatory="$t('lbl_EMPBE_ProductNameCn') + $t('lbl_IsRequire')
                            " :title="$t('lbl_EMPBE_ProductNameCn')" data-item="productnameChi"
                            v-model="form.productnameChi"
                            >
                          </textbox>
                        </div>
                      </div>
                      <div class="row">
                        <div class="col">
                          <div class="" ref="keywordTitle">
                            <h6>
                              {{ $t("lbl_EMPBE_Keyword") }}
                              <i class="fa fa-info-circle m-l-5 m-r-5" v-bind:t_label="'EMPBE_Prod_DetailIntro_Info'"
                                id="KeywordInfo"></i>
                              <b-tooltip target="KeywordInfo" triggers="hover" placement="right">
                                <span v-html="$t('lbl_EMPBE_Keyword_info', {
                                  0: permissionData?.MaxProdKeyword
                                    ? permissionData?.MaxProdKeyword
                                    : 3,
                                })
                                  "></span>
                              </b-tooltip>
                              <b-button class="btn-xs btn-pill btn-dark ml-3" variant="dark" @click="addKeyword"
                                v-if="form.keywordList.length < keywordLimit">
                                <i class="fa fa-plus-circle" role="button">
                                  {{ $t("lbl_EMPBE_Add") }}</i>
                              </b-button>
                            </h6>
                            <div class="row" style="padding-top: 10px">
                              <div :class="index % 2 == 1 ? 'col-5 row' : 'col-4'"
                                v-for="(item, index) in form.keywordList" :key="index">
                                <div :class="index % 2 == 1 ? 'col-10' : ''">
                                  <textbox :title="item.langId == '1252'
                                    ? $t('lbl_EMPBE_Eng')
                                    : $t('lbl_EMPBE_Chi')
                                    " :CharLimit="item.langId == '1252' ? 'CheckEnglishChar' : ''
    " v-model="item.keywords" >
                                  </textbox>
                                </div>
                                <div v-if="index % 2 == 1 && index != 1">
                                  <i class="fa fa-minus-circle" @click="removeKeyword(index)" role="button"></i>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div class="row">
                        <div class="col">
                          <h6>
                            {{ $t("lbl_EMPBE_ProductModel") }}
                          </h6>
                          <textbox v-model="form.modelNum" data-item="modelNum">
                          </textbox>
                        </div>
                      </div>
                      <div class="row" >
                        <div class="col-12">
                          <h6>{{ $t("lbl_EMPBE_ProductionCapacity") }}</h6>
                          <div class="row">
                            <div class="col-sm-4 p-r-0">
                              <textbox type="number" :placeholder="$t('lbl_EMPBE_OnlyNumAreAllowed')"
                                v-model="form.AbilityNumber"></textbox>
                            </div>
                            <div class="col-sm-8 p-l-0">
                              <div class="row">
                                <div class="col-sm-4 p-r-0" style="
                                    padding: 0px !important;
                                    padding-left: 15px !important;
                                  ">
                                  <selection :placeholder="$t('Lbl_PleaseSelect')" label="name"
                                    :options="options_SupplyUnit" style="flex: auto" v-model="form.SupplyUnit">
                                  </selection>
                                </div>
                                <div class="col-sm-4 p-r-0" style="padding: 0px !important" v-if="form.SupplyUnit == 99">
                                  <textbox type="text" v-model="form.SupplyUnitOther"></textbox>
                                </div>
                                <div class="col-sm-1 p-r-0" style="padding: 0px !important">
                                  <span class="form-control" style="flex: 1; font-size: 15px">/</span>
                                </div>
                                <div class="col-sm-3 p-r-0" style="padding: 0px !important">
                                  <selection :placeholder="$t('Lbl_PleaseSelect')" label="name"
                                    :options="options_SupplyTime" style="flex: auto; width: 170px"
                                    v-model="form.SupplyTime">
                                  </selection>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div class="row" >
                        <div class="col">
                          <h6>{{ $t("lbl_EMPBE_MOQ") }}</h6>
                          <div class="row">
                            <div class="col-sm-4 p-r-0">
                              <textbox type="number" :placeholder="$t('lbl_EMPBE_OnlyNumAreAllowed')"
                                v-model="form.MoqNumber">
                              </textbox>
                            </div>
                            <div class="col-sm-8 p-l-0">
                              <div class="row">
                                <div class="col-sm-4 p-r-0" style="
                                    padding: 0px !important;
                                    padding-left: 15px !important;
                                  ">
                                  <selection :placeholder="$t('Lbl_PleaseSelect')" label="name"
                                    :options="options_SupplyUnit" v-model="form.MoqSupplyUnit">
                                  </selection>
                                </div>
                                <div class="col-sm-4 p-r-0" style="padding: 0px !important"
                                  v-if="form.MoqSupplyUnit == 99">
                                  <textbox type="text" v-model="form.MoqSupplyUnitOther"></textbox>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div class="row">
                        <div class="col-12">
                          <PricingDisplay :modelValue="form.price"></PricingDisplay>
                          
                        </div>
                        
                      </div>
                      <div class="row" >
                        <div class="col-12">
                          <h6>{{ $t("lbl_EMPBE_ShippingPort") }}</h6>
                        </div>
                        <div class="col-12">
                          <div class="row">
                            <div class="col-4">
                              <selection :placeholder="$t('lbl_EMPBE_Country')" label="name" :options="options_country"
                                v-model="form.SelectedCountry" data-item="SelectedCountry">
                              </selection>
                            </div>
                            <div class="col-4" v-if="isCountrySelectedCN || form.SelectedCountry == ''">
                              <selection :placeholder="$t('lbl_EMPBE_Province')" label="name" :options="options_province"
                                v-model="form.SelectedProvince" data-item="SelectedProvince" ref="selectionProvince">
                              </selection>
                            </div>
                            <div class="col-4" v-if="isCountrySelectedCN || form.SelectedCountry == ''">
                              <selection :placeholder="$t('lbl_EMPBE_City')" label="name" :options="options_city"
                                v-model="form.SelectedCity" ref="selectionProvince">
                              </selection>
                            </div>
                            <div class="col-8" v-if="!isCountrySelectedCN &&
                              !isCountrySelectedHK &&
                              form.SelectedCountry != ''
                              ">
                              <textbox :title="$t('lbl_EMPBE_PortCityEn')" v-model="form.PortCityEng"></textbox>
                              <textbox :title="$t('lbl_EMPBE_PortCityCn')" v-model="form.PortCityChi"></textbox>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div class="row">
                        <div class="col">
                          <div class="form-group">
                            <h6>
                              {{ $t("Lbl_CatName") }}
                              <span class="text-danger">*</span>
                              <i class="fa fa-info-circle m-l-5 m-r-5" v-bind:t_label="'EMPBE_Prod_Cat_Info'"
                                id="CatInfo"></i>
                              <b-tooltip target="CatInfo" triggers="hover" placement="right">
                                {{
                                  $t("lbl_Product_Cat_Info").replace(
                                    "#count#",
                                    permissionData != null
                                      ? permissionData["MaxProdCataCount"]
                                      : 0
                                  )
                                }}
                              </b-tooltip>
                            </h6>
                            <multiselection v-model="form.productCats" label="name" :placeholder="$t('Lbl_PleaseSelect')"
                              :options="options_productCats" :data-parent="options_productCats.parent" :multiple="true"
                              :taggable="true" :MaxLength="permissionData != null
                                ? permissionData['MaxProdCataCount']
                                : 0
                                " @select="selected" @delselect="delselect"
                              :mandatory="$t('Lbl_CatName') + $t('lbl_IsRequire')">
                            </multiselection>
                          </div>
                        </div>
                      </div>

                      <div class="row">
                        <div class="col">
                          <div class="form-group">
                            <h6>
                              {{ $t("lbl_ApplicationIndustries") }}
                              <span class="text-danger">*</span>
                              <i class="fa fa-info-circle m-l-5 m-r-5" v-bind:t_label="'EMPBE_Prod_App_Info'"
                                id="AppInfo"></i>
                              <b-tooltip target="AppInfo" triggers="hover" placement="right">
                                {{
                                  $t("lbl_Product_App_Info").replace(
                                    "#count#",
                                    permissionData != null
                                      ? permissionData["MaxProdIndustriesCount"]
                                      : 0
                                  )
                                }}
                              </b-tooltip>
                            </h6>
                            <multiselection v-model="form.applicationIndustries" :placeholder="$t('Lbl_PleaseSelect')"
                              label="name" :MaxLength="permissionData != null
                                ? permissionData['MaxProdIndustriesCount']
                                : 0
                                " :options="options_applicationIndustries" :multiple="true" :mandatory="$t('lbl_ApplicationIndustries') + $t('lbl_IsRequire')
    ">
                            </multiselection>
                          </div>
                        </div>
                      </div>
                    </b-collapse>
                    <h5 v-b-toggle.divPromoInfo class="mb-3 font-info">
                      <i class="icofont icofont-caret-right" v-if="!divPromoInfoVisible"></i>
                      <i class="icofont icofont-caret-down" v-if="divPromoInfoVisible"></i>
                      {{ $t("lbl_EMPBE_ProductPromotionInformation") }}
                    </h5>
                    <b-collapse id="divPromoInfo" class="col-12" v-model="divPromoInfoVisible">
                      <div class="row">
                        <div class="col">
                          <h6>
                            {{ $t("Lbl_RelatedLabel") }}
                            <i class="fa fa-info-circle m-l-5 m-r-5" v-bind:t_label="'EMPBE_Prod_Tag_Info'"
                              id="TagInfo"></i>
                            <b-tooltip target="TagInfo" triggers="hover" placement="right">
                              {{
                                $t("lbl_maximumchoices").replace(
                                  "#count#",
                                  permissionData != null
                                    ? permissionData["MaxHashtagCount"]
                                    : 0
                                )
                              }}
                            </b-tooltip>
                          </h6>
                          <multiselection label="name" v-model="form.selectedHotSearchTags"
                            :placeholder="$t('Lbl_PleaseSelect')" :MaxLength="permissionData != null
                              ? permissionData['MaxHashtagCount']
                              : 0
                              " :options="options">
                          </multiselection>
                        </div>
                      </div>
                      <div v-if="levelType != '' && levelType != 'Guest'">
                        <div class="row">
                          <div class="col-12">
                            <h6>{{ $t("lbl_EMPBE_NewLaunchToMarket") }}</h6>
                            <div class="row">
                              <div class="col-sm-2">
                                <switchIput data-item="isNewProduct" v-model="form.isNewProduct">
                                </switchIput>
                              </div>
                              <div class="col-sm-4" v-if="form.isNewProduct">
                                <selection :title="$t('lbl_EMPBE_NewProdRange')" label="name" :options="options_NewProd"
                                  v-model="form.newTech" data-item="newTech">
                                </selection>
                              </div>
                              <div class="col-sm-4" v-if="form.isNewProduct">
                                <datePicker_cp :title="$t('lbl_EMPBE_NewTechLaunchDate')"
                                  input-class="datepicker-here form-control digits" v-model="form.NewProdPostDate"
                                  :value="form.NewProdPostDate" :dateTimeFormat="'yyyy-MM-dd'" data-item="NewProdPostDate"
                                  @fromChird_selectDate="handleDateChange">
                                </datePicker_cp>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      
                      <div class="row">
                        <!--[13082024][SJP] Isaac Request to hide-->
                        <div v-if="false" :class="{ 'col-sm-6': langid != 1252, 'col-sm-12': langid == 1252 }">
                          <switchIput :title="$t('lbl_EMPBE_DisplayInCPS')" v-model="form.IsDisplayInShow"
                            data-item="IsDisplayInShow">
                          </switchIput>
                        </div>
                        <div :class="{ 'col-sm-6': langid != 1252, 'col-sm-12': langid == 1252 }">
                          <switchIput :title="$t('lbl_EMPBE_ProvideFreeSample')" v-model="form.IsProvideFreeSample"
                            data-item="IsProvideFreeSample">
                          </switchIput>
                        </div>
                      </div>
                    </b-collapse>

                    <h5 v-b-toggle.divDescInfo class="mb-3 font-info">
                      <i class="icofont icofont-caret-right" v-if="!divDescInfoVisible"></i>
                      <i class="icofont icofont-caret-down" v-if="divDescInfoVisible"></i>
                      {{ $t("lbl_EMPBE_ProdDesc") }}
                    </h5>
                    <b-collapse id="divDescInfo" class="col-12" v-model="divDescInfoVisible">
                      <div class="row">
                        <div class="col" style="padding-bottom: 20px">
                          <div v-html="$t('lbl_EMPBE_ProdcutDescDesc')"></div>
                        </div>
                      </div>
                      <div class="row">
                        <div class="col">
                          <h6>
                            {{ $t("lbl_EMPBE_ProductDescEn")
                            }}<span class="text-danger"> *</span>
                          </h6>
                          <customtextarea rows="3" max="1000" v-model="form.productDescEng" data-item="productDescEng"
                            :customErrorMessage="{ max: $t('lbl_EMPBE_PIG_InputExceedLimit') }"
                            :placeholder="$t('lbl_EMPBE_ProductDescEnPlaceholder')" :mandatory="$t('lbl_EMPBE_ProductDescEn') + $t('lbl_IsRequire')
                              " :isHideStar="true" CharLimit="CheckEnglishChar">
                          </customtextarea>
                        </div>
                      </div>
                      <div class="row">
                        <div class="col">
                          <h6>
                            {{ $t("lbl_EMPBE_ProductDescCn")
                            }}<span class="text-danger" v-if="langid != 1252"> *</span>
                          </h6>
                          <customtextarea ControlId="productDescChi" rows="3" max="500" v-model="form.productDescChi"
                            :customErrorMessage="{ max: $t('lbl_EMPBE_PIG_InputExceedLimit') }"
                            data-item="productDescChi" :placeholder="$t('lbl_EMPBE_ProductDescCnPlaceholder')" :mandatory="$t('lbl_EMPBE_ProductDescCn') + $t('lbl_IsRequire')
                              " :isHideStar="true">
                          </customtextarea>
                        </div>
                      </div>
                    </b-collapse>

                    <h5 v-b-toggle.divMediaInfo class="mb-3 font-info">
                      <i class="icofont icofont-caret-right" v-if="!divMediaInfoVisible"></i>
                      <i class="icofont icofont-caret-down" v-if="divMediaInfoVisible"></i>
                      {{ $t("lbl_EMPBE_ProductMediaInfo") }}
                    </h5>
                    <b-collapse id="divMediaInfo" class="col-12" v-model="divMediaInfoVisible">
                      <div class="row">
                        <div class="row col-12 form-group">
                          <div class="col-12">
                            <h6>
                              {{ $t("lbl_EMPBE_ProductPhoto") }}
                              <span class="text-danger">*</span>
                              <!-- <i class="fa fa-info-circle m-l-5 m-r-5" v-bind:t_label="'EMPBE_Prod_photo_Info'"
                                id="PhotoInfo"></i>
                              <b-tooltip target="PhotoInfo" triggers="hover" placement="right">
                              </b-tooltip> -->
                            </h6>
                            <div class="mb-2"
                              v-html="$t('lbl_EMPBE_ProductPhotoDesc').replace('{0}', ExhibitPhotoLimit).replace('{1}', ExhibitPhotoLimit - 1)">
                            </div>
                            <div id="err_img_msg">
                              <span style="color: #dc3545" v-if="err_img_msg != ''">
                                {{ err_img_msg }}
                              </span>
                            </div>
                          </div>
                          <div class="col-12">
                            <imageUpload componentId="ExhibitPhoto" :limit="ExhibitPhotoLimit" ref="ExhibitPhoto"
                              :mandatory="'test'" :imageArray="form.imgArr" :aspectRatioselected="1.4">
                            </imageUpload>
                          </div>
                        </div>
                      </div>
                      <div v-if="permissionData != null">
                        <div class="row" v-show="permissionData['MaxProdVideo'] > 0 || isBoughtVG">
                          <div class="row col-12 form-group">
                            <div class="col-12">
                              <h6>
                                {{ $t("lbl_EMPBE_ProductVideo") }}
                                <!-- <i class="fa fa-info-circle m-l-5 m-r-5" v-bind:t_label="'EMPBE_Prod_video_Info'"
                                  id="VideoInfo"></i>
                                <b-tooltip target="VideoInfo" triggers="hover" placement="right">
                                  {{ $t("lbl_EMPBE_ProductVideoDesc") }}
                                </b-tooltip> -->
                              </h6>
                              <div class="mb-2" v-html="$t('lbl_EMPBE_ProductVideoDesc')"></div>
                              <videoUpload componentId="ExhibitVideo" ref="ExhibitVideo" :aspectRatioselected="1.3333"
                                :videoArray="form.videoArr">
                              </videoUpload>
                            </div>
                          </div>
                        </div>
                        <div class="row" v-show="permissionData['MaxProdVideo'] > 0 || isBoughtVG">
                          <div class="row col-12 form-group">
                            <div class="col-12">
                              <h6>
                                {{ $t("lbl_EMPBE_ProductShortVideo") }}&nbsp;&nbsp;<span class="NewsTips">{{$t("lbl_EMPBE_News") }}</span>
                              </h6>
                              <div class="mb-2" v-html="$t('lbl_EMPBE_ProductShortVideoDesc')"></div>
                              <videoUpload componentId="ExhibitVideo_Short" ref="ExhibitVideo_Short" :aspectRatioselected="0.5625"
                                :videoArray="form.shortVideoArr" :verticalCover="true">
                              </videoUpload>
                            </div>
                          </div>
                        </div>
                      </div>
                    </b-collapse>

                    <div class="customizer-formbutton" v-if="$route.params.id">
                      <b-button-group>
                        <button class="btn btn-light btn-lg" @click="btnDelete_Click" v-bind:t_label="'EMPBE_ProductInfoCenter_Product_' +
                          form.productId +
                          '_btnDelete'
                          ">
                          <i class="fa fa-trash-o m-r-5"></i>{{ $t("lbl_EMPBE_Delete") }}
                        </button>
                        <b-dropdown :text="$t('lbl_EMPBE_PreviewPage')" size="lg" variant="primary" v-if="false">
                          <b-dropdown-item>
                            <i class="icofont icofont-monitor m-r-5"></i>{{ $t("lbl_EMPBE_PC") }}
                          </b-dropdown-item>
                          <b-dropdown-item>
                            <i class="icofont icofont-android-tablet m-r-5"></i>{{ $t("lbl_EMPBE_Mobile") }}
                          </b-dropdown-item>
                        </b-dropdown>
                        <button class="btn btn-primary btn-lg" @click="btnSave_Click" v-if="lastSubmitDate == '-'"
                          v-bind:t_label="'EMPBE_ProductInfoCenter_Product_' +
                            form.productId +
                            '_btnSave'
                            ">
                          <i class="fa fa-save m-r-5"></i>{{ $t("lbl_EMPBE_SaveDraft") }}
                        </button>
                        <button class="btn btn-success btn-lg" @click="btnSubmit_Click" v-bind:t_label="'EMPBE_ProductInfoCenter_Product_' +
                          form.productId +
                          '_btnSubmit'
                          ">
                          <i class="fa fa-send m-r-5"></i>{{ $t("lbl_EMPBE_SaveAndSubmit") }}
                        </button>
                      </b-button-group>
                    </div>
                  </ValidationObserver>
                </div>
              </div>
            </div>
          </div>
        </b-overlay>
      </div>
    </div>
  </div>
</template>
<script>
import { mapGetters } from "vuex";
import { productService } from "@/_services/product.service";
import { CompanyInfoService } from '@/_services/CompanyInfo.Service';
import { fileUploadService, userService } from "../../_services";
import PricingDisplay from "../../components/PricingDisplay.vue";

export default {
  components: {PricingDisplay},
  props: ["supplierId", "ProductId", "fromAdmin"],
  inject: ["permissionData"],
  data() {
    return {
      dirty: false,
      loading: false,
      IsSave: false,
      IsSubmit: false,
      isUpdate: false,
      originalData: {},
      saveupdatedDate: "-",
      lastSubmitDate: "-",
      lastThreeMonthSubmitCount: "-",
      keywordLimit: 3 * 2,
      levelType: "",
      form: {
        empCompanyId: 0,
        productId: 0,
        seqId: 0,
        txtkeywordListEng: [],
        txtkeywordListChi: [],
        keyword: { productId: 0, keywords: "", langId: 950, orderId: 0 },
        keywordList: [
          { keywords: "", langId: 1252, OrderId: 1, productId: 0 },
          { keywords: "", langId: 950, OrderId: 1, productId: 0 },
        ],
        productnameEng: "",
        productnameChi: "",
        productDescEng: "",
        productDescChi: "",
        isNew: false,
        isActivate: false,
        isMainProd: false,
        isLaunch: true,
        isMainProduct: false,
        isNewProduct: false,
        MoqNumber: null,
        AbilityNumber: null,
        applicationIndustries: [],
        SelectedCountry: null,
        SelectedCity: null,
        SelectedProvince: null,
        PortCityChi: "",
        PortCityEng: "",
        NewProdPostDate: null,
        newTech: null,
        IsDisplayInShow: false,
        IsProvideFreeSample: false,
        modelNum: "",
        productCats: [],
        selectedHotSearchTags: null,
        SupplyTime: null,
        SupplyUnit: null,
        SupplyUnitOther: "",
        MoqSupplyUnit: null,
        MoqSupplyUnitOther: "",
        files: [
          { EmpCompanyId: 0, UsageType: "ExhibitPhoto", FileName: "", EmpProductID: 0 },
          { EmpCompanyId: 0, UsageType: "ExhibitVideo", FileName: "", EmpProductID: 0 },
          {EmpCompanyId: 0, UsageType: "ExhibitVideo_Short", FileName: "", EmpProductID: 0 },
          {
            EmpCompanyId: 0,
            UsageType: "ExhibitVideo_Cover",
            FileName: "",
            EmpProductID: 0,
          },
          {
            EmpCompanyId: 0,
            UsageType: "ExhibitVideo_Short_Cover",
            FileName: "",
            EmpProductID: 0,
          },
        ],
        imgArr: [],
        videoArr: [],
        shortVideoArr: [],
        video: {},
        video_cover: {},
        TempExhibitCats: [],
        price:{
          ProductPriceDisplay: true,
          ProductPriceCurrUnit: "1",
          ProductPriceAmount: '0.00',
          ProductPriceAmountMax: '0.00',
          ProductPriceItemUnit: "4",
          ProductPriceRange: false,
          ProductPriceItemUnitOther: ''
        }
      },
      isCountrySelectedCN: false,
      isCountrySelectedHK: false,
      city: [],
      country: [],
      resProv: [],
      options_city: [],
      options_province: [],
      options_NewProd: [],
      options: [],
      options_country: [],
      options_SupplyUnit: [],
      options_SupplyTime: [],
      options_applicationIndustries: [],
      options_productCats: [],
      ExhibitPhotoLimit: 5,
      err_img_msg: "",
      divbasicInfoVisible: true,
      divPromoInfoVisible: true,
      divDescInfoVisible: true,
      divMediaInfoVisible: true,

      QRCodeOSSURL: "",
      QRCodeStatus: "",
      IsPending: true,
      FetchQRCodeTime: 0,
      ReFetchLimit: 5,
    };
  },
  computed: {
    ...mapGetters({
      getPermissionJsonByUser: "responsePermission/getPermissionJsonByUser",
    }),
    user() {
      return this.$store.state.authentication.user;
    },
    companyid() {
      return this.supplierId === null ||
        this.supplierId === undefined ||
        this.supplierId === ""
        ? this.user.empCompanyId
        : this.supplierId;
    },
    langid() {
      return localStorage.getItem("currentLangId");
    },
    isBoughtVG() {
      //Check if the account has bought vg
      if (this.user.extraPermissions) {
        return this.user.extraPermissions.itemName.includes("VisitorGuide_eForm")
      }
      return false

    }
  },
  watch: {
    "$route.params.id": function () {
      this.refresh();
    },
    "form.SelectedCountry": function (newValue, oldValue) {
      if (newValue != oldValue) {
        this.SelectedCountryChange();
      }
      this.isCountrySelectedCN = newValue == 44;
      this.isCountrySelectedHK = newValue == 96 || newValue == 125 || newValue == 206;
    },
    "form.SelectedProvince": function (newValue, oldValue) {
      this.SelectedProvinceChange();
    },
    "form.SelectedCity": function (newValue, oldValue) { },
    "form.selectedHotSearchTags": function (newValue, oldValue) {
      //console.log("form.selectedHotSearchTags=" + this.form.selectedHotSearchTags);
    },
    "form.keywordList": function (newValue, oldValue) {
      // console.log("form.keywordList")
      // console.log(this.form.keywordList)
    },
    "form.applicationIndustries": function (newValue, oldValue) {
      //console.log("form.applicationIndustries");
      //console.log(newValue);
    },
    form: {
      handler() {
        this.dirty = true;
        this.$store.state.dirty = this.dirty;
        //console.log("产品 dirty");
        //console.log(this.$store.state.dirty);
      },
      deep: true,
    },
    dirty: {
      handler() {
        this.$store.state.dirty = this.dirty;
      },
    },
    permissionData: {
      handler() {
        setTimeout(() => {
          this.initPermissionData();
        }, 500);
      },
      deep: true,
    },
    "form.imgArr": {
      handler(newval, oldval) {
        var arr = [];
        newval.forEach((element) => {
          if (element.FileName != "") {
            arr.push(element);
          }
        });
        if (arr.length > 0) {
          this.err_img_msg = "";
          //this.err_img_msg=this.$t('lbl_EMPBE_Product')+this.$t('Lbl_SponsorPho')+this.$t('lbl_IsRequire')
        }
      },
      deep: true,
    },
  },
  mounted() { },
  created() {
    this.refresh();
    this.$watch(
      () => this.$route.params,
      (toParams, previousParams) => {
        this.refresh();
      }
    );
  },
  methods: {
    initPermissionData() {
      if (this.permissionData != null) {
        this.ExhibitPhotoLimit = this.permissionData.MaxProdPhoto;
        this.keywordLimit = this.permissionData?.MaxProdKeyword * 2;
        this.levelType = this.permissionData.Type;
      }
    },
    SelectedCountryChange() {
      if (this.form.SelectedCountry === 44) {
        this.options_province = [];
        this.MapProvinceDataToOptions()
      }
    },
    SelectedProvinceChange() {
      var c = this.MappCityDataToOptions()

      if (c.length == 1) {
        this.form.SelectedCity = c[0].city_id;
      } else {
        this.form.SelectedCity = undefined;
      }
    },
    btnCancel_Click() {
      this.$swal({
        text: this.$t("lbl_EMPBE_ConfirmToCancel"),
        showCancelButton: true,
        confirmButtonText: this.$t("lbl_EMPBE_Confirm"),
        cancelButtonText: this.$t("lbl_EMPBE_Cancel"),
      }).then((res) => {
        if (res.isConfirmed) {
          this.refresh();
        }
      });
    },
    btnSave_Click() {
      //console.log("btnSave_Click");
      this.$swal({
        text: this.$t("lbl_EMPBE_ConfirmToSave"),
        showCancelButton: true,
        confirmButtonText: this.$t("lbl_EMPBE_Confirm"),
        cancelButtonText: this.$t("lbl_EMPBE_Cancel"),
      }).then(async (res) => {
        if (res.isConfirmed) {
          //[19112024][SJP] Per isaac request, remove mainproduct count checking
          // if (this.form.isMainProduct) {
          //   var checkMainProdCount = await this.GetProductMainProdCount();
          //   if (!checkMainProdCount) {
          //     return;
          //   }
          // }
          if (true) { //[20231113][JWS] isLaunch always is true this.form.isLaunch
            this.IsSave = true;
            this.checkProductLaunch();
          } else {
            this.todoSave();
          }
        }
      });
    },
    btnSubmit_Click() {
      var that = this;
      this.$swal({
        text: this.$t("lbl_EMPBE_ConfirmToSubmit"),
        showCancelButton: true,
        confirmButtonText: this.$t("lbl_EMPBE_Confirm"),
        cancelButtonText: this.$t("lbl_EMPBE_Cancel"),
      }).then(async (res) => {
        if (res.isConfirmed) {
          this.$refs.observer.validate().then(async (res) => {
            if (res) {
              if (this.form.imgArr.length <= 0) {
                this.err_img_msg =
                  this.$t("lbl_EMPBE_ProductPhoto") +
                  this.$t("lbl_IsRequire");
                return;
              }
              //[19112024][SJP] Per isaac request, remove mainproduct count checking
              // if (this.form.isMainProduct) {
              //   var checkMainProdCount = await this.GetProductMainProdCount();
              //   if (!checkMainProdCount) {
              //     return;
              //   }
              // }
              if (true) { //[20231113][JWS] isLaunch always is true this.form.isLaunch
                this.IsSubmit = true;
                this.checkProductLaunch();
              } else {
                this.todoSubmit();
              }
            } else {
              // //scrollTo first error
              // if (this.form.keywordList.length > 0) {
              //   var that = this;
              //   var list = this.form.keywordList.filter(
              //     (x) => x.OrderId == 1 && x.keywords == ""
              //   );
              //   if (list.length > 0) {
              //     var element = this.$refs.keywordTitle;
              //     let position = element.getBoundingClientRect();
              //     var top = position.top + 300;
              //     setTimeout(() => {
              //       element.scrollIntoView({ top: top, behavior: "smooth" });
              //     }, "300");
              //     return;
              //   }
              // }

              //[20240205][JWS] Auto save
              var Params = await this.GetParam();
              //console.log(Params);
              productService
                .saveProdutAsync(Params)
                .then((res) => {
                  if (res.isSuccessful) {
                    that.showRequiredFieldAlert();
                    if (that.form.productId != res.data) {
                      that.$router.push({
                        name: that.$router.currentRoute.name,
                        params: { id: res.data },
                      });
                      that.$parent.$parent.$parent.$parent.openSidebarAfterSave();
                    }
                    that.refreshParent();
                    that.refresh();
                  }
                });
              //scrollTo first error
              for (const key of Object.keys(this.$refs.observer.fields)) {
                if (this.$refs.observer.fields[key].invalid) {
                  var element = this.$refs.observer.refs[key].$el;
                  let position = element.getBoundingClientRect();
                  var top = position.top + 300;
                  setTimeout(() => {
                    element.scrollIntoView({ top: top, behavior: "smooth" });
                  }, "300");
                  return;
                }
              }
            }
          });
        }
      });
    },
    btnDelete_Click() {
      this.$swal({
        text: this.$t("lbl_deleteProduct_msg"),
        showCancelButton: true,
        confirmButtonText: this.$t("lbl_EMPBE_Confirm"),
        cancelButtonText: this.$t("lbl_EMPBE_Cancel"),
      }).then(async (res) => {
        if (res.isConfirmed) {
          var isDeleted = await this.Delete();
          if (isDeleted) {
            this.refresh();
            this.refreshParent();
            this.$router.replace("/productInfoCenter/default");
          }
        }
      });
    },
    //刷新父级
    refreshParent() {
      // this.$parent.$emit('fetchData');
      this.$parent.$parent.$parent.$parent.refresh();
    },
    //刷新
    refresh() {
      Object.assign(this.$data, this.$options.data());
      // if (!this.supplierId) {
      //   this.refreshParent();
      // }
      this.initPermissionData();
      this.initData();
    },
    /*
日期控件，获取值
*/
    handleDateChange(newDate) {
      //console.log("选中的日期: ", newDate);
      this.form.NewProdPostDate = newDate;
    },
    //多选 选择事件
    selected(node) {
      if (node["id"]) {
        var num = this.form.TempExhibitCats.length + 1;
        var TempExhibitCat = {
          ProductId: this.form.productId,
          SubId: node["id"],
          MainId: node["parent"],
          OrderId: num,
        };
        this.form.TempExhibitCats.push(TempExhibitCat);
      }
      // console.log(this.form.TempExhibitCats)
    },
    //多选 删除选择事件
    delselect(node) {
      var TempExhibitCats = [];
      // console.log(node)
      this.form.TempExhibitCats.forEach((element, index) => {
        //console.log(node["id"])
        //console.log(element["subId"])
        if (element["subId"]) {
          if (node["id"] != element["subId"]) {
            var TempExhibitCat = {
              ProductId: this.form.productId,
              SubId: element["subId"],
              MainId: element["mainId"],
              OrderId: index + 1,
            };

            TempExhibitCats.push(TempExhibitCat);
          }
        }
      });
      
      this.form.TempExhibitCats = TempExhibitCats;
      // console.log(this.form.TempExhibitCats)
    },
    /*
  1、获取基础数据
  2、初始化数据
  */
    initData() {
      var that = this;
      var form = this.form;
      that.loading = true;
      form.empCompanyId = this.companyid;
      form.productId = this.$route.params.id ? this.$route.params.id : this.ProductId;
      var parms = {
        LangId: this.langid,
        CompanyId: this.companyid,
      };
      //应用行业
      productService.GetIndustryByCompanyId(parms).then((response) => {
        if (response.isSuccessful) {
          var dataList = response.data;
          this.options_applicationIndustries = dataList;
        }
      });
      //产品类别
      productService.GetProductCatByCompanyId(parms).then((response) => {
        if (response.isSuccessful) {
          var dataList = response.data;
          //console.log("dataList");
          //console.log(dataList);
          this.options_productCats = dataList;
        }
      }); // end 加载品类
      var parms2 = {
        LangId: this.langid,
      };
      //加载热搜标签
      productService.GetMstTag(parms2).then((res) => {
        if (res.isSuccessful) {
          this.options = [];
          //console.log(res);
          for (let index = 0; index < res.data.length; index++) {
            var item = {
              id: res.data[index].tagId,
              label: res.data[index].text,
            };
            this.options.push(item);
          }
        }
      });
      //
      productService
        .GetMstKeyValueMapping({ type: "UOM", langId: this.langid })
        .then((res) => {
          if (res.isSuccessful) {
            this.options_SupplyUnit = [];
            //console.log("UOM", res.data);
            for (let index = 0; index < res.data.length; index++) {
              var item = {
                id: res.data[index].code,
                label: res.data[index].text,
              };
              this.options_SupplyUnit.push(item);
            }
          }
        });

      productService
        .GetMstKeyValueMapping({ type: "Abilityunit", langId: this.langid })
        .then((res) => {
          if (res.isSuccessful) {
            this.options_SupplyTime = [];
            //console.log("Abilityunit", res.data);
            for (let index = 0; index < res.data.length; index++) {
              var item = {
                id: res.data[index].code,
                label: res.data[index].text,
              };
              this.options_SupplyTime.push(item);
            }
          }
        });
      //加载新品选项
      productService
        .GetMstKeyValueMapping({ type: "Newarea", langId: this.langid })
        .then((res) => {
          if (res.isSuccessful) {
            this.options_NewProd = [];
            for (let index = 0; index < res.data.length; index++) {
              var item = {
                id: res.data[index].code,
                label: res.data[index].text,
              };
              this.options_NewProd.push(item);
            }
          }
        });
      productService.GetCountryProvCityArea({ langId: this.langid }).then((res) => {
        if (res.isSuccessful) {
          this.city = res.data.city;
          this.country = res.data.country;
          this.resProv = res.data.resProv;

          var chinaElement = {};

          //console.log(res.data);
          this.options_country = [];
          this.country.forEach((element) => {
            var item = {
              id: element.countryID,
              label: element.countryName,
            };
            if (
              element.countryID == 125 ||
              element.countryID == 96 ||
              element.countryID == 206
            ) {
              this.options_country.unshift(item);
            } else if (element.countryID == 44) {
              chinaElement = item;
            } else {
              this.options_country.push(item);
            }
          });
          this.MapProvinceDataToOptions()
          this.MappCityDataToOptions()
          this.options_country.unshift(chinaElement);
        }
      });
      //Get QRCode of product
      this.GetQRCode()


      //初始化数据
      if (form.productId > 0) {
        productService
          .getTempCompanyExhibitDetails({
            companyId: this.companyid,
            ProductId: form.productId,
          })
          .then((res) => {
            //console.log("初始化 查询数据：", res);
            if (res.isSuccessful) {
              var data = res.data;
              //console.log("结果", data);
              let productPriceAmount = data.tempCompanyProperties.find(x => x.propertyName == 'ProductPriceAmount')?.content
              let productPriceAmountMax = data.tempCompanyProperties.find(x => x.propertyName == 'ProductPriceAmountMax')?.content
              let productPriceItemUnit = data.tempCompanyProperties.find(x => x.propertyName == 'ProductPriceItemUnit')?.content
              let productPriceCurrUnit = data.tempCompanyProperties.find(x => x.propertyName == 'ProductPriceCurrUnit')?.content
              form.price = {
                ProductPriceDisplay: data.tempCompanyProperties.find(x => x.propertyName == 'ProductPriceDisplay')?.content != 'true' ? false : true,
                ProductPriceCurrUnit: productPriceCurrUnit ? productPriceCurrUnit : "1",
                ProductPriceRange: data.tempCompanyProperties.find(x => x.propertyName == 'ProductPriceRange')?.content != "true" ? false : true,
                ProductPriceAmount: productPriceAmount ? productPriceAmount : "0.00",
                ProductPriceAmountMax: productPriceAmountMax ? productPriceAmountMax : "0.00",
                ProductPriceItemUnit: productPriceItemUnit ? productPriceItemUnit : "4",
                ProductPriceItemUnitOther: data.tempCompanyProperties.find(x => x.propertyName == 'ProductPriceItemUnitOther')?.content
              }
              var tempCompanyExhibit = data.tempCompanyExhibit;

              (form.empCompanyId = tempCompanyExhibit.empCompanyId),
                (form.productId = tempCompanyExhibit.productId);
              form.isNew = tempCompanyExhibit.isNewTech;
              form.isActivate = tempCompanyExhibit.isActivate;
              form.isMainProd = tempCompanyExhibit.isMainProd;
              this.saveupdatedDate =
                tempCompanyExhibit.updatedDate == null ||
                  tempCompanyExhibit.updatedDate == ""
                  ? tempCompanyExhibit.createdDate
                  : tempCompanyExhibit.updatedDate;
              //已上架
              form.isLaunch = true;  //[20231113][JWS] isLaunch always is true tempCompanyExhibit.isLaunch
              //主打产品
              form.isMainProduct = tempCompanyExhibit.isMainProduct;
              //产品是否属于新推出市场?
              form.isNewProduct = tempCompanyExhibit.isNewProduct;
              //新品选择
              form.newTech = tempCompanyExhibit.newTech;
              //产品新品发布日期
              form.NewProdPostDate = tempCompanyExhibit.premiereDate;
              //产品是否会在「2022国际橡塑展」现场进行展示？
              form.IsDisplayInShow = tempCompanyExhibit.isDisplayInShow;
              //是否愿意提供免费产品样品于感兴趣的买家？
              form.IsProvideFreeSample = tempCompanyExhibit.isProvideFreeSample;
              //产品名称 / 标题 (英文)
              form.productnameEng = tempCompanyExhibit.exhibitNameE;
              //产品名称 / 标题 (中文)
              form.productnameChi = tempCompanyExhibit.exhibitNameT;
              //英文产品简介 *
              form.productDescEng = tempCompanyExhibit.descE;
              //中文产品简介 *
              form.productDescChi = tempCompanyExhibit.descT;
              //港口城市 (英文)
              form.PortCityEng = tempCompanyExhibit.shippingPortCityEn;
              //港口城市 (中文)
              form.PortCityChi = tempCompanyExhibit.shippingPortCityCn;
              //发货港口 (国家/省/市)
              form.SelectedCountry = tempCompanyExhibit.shippingPortCountry;
              // that.SelectedCountryChange();
              that.$nextTick(() => {
                form.SelectedProvince = tempCompanyExhibit.shippingPortProvince;
              })
              // that.SelectedProvinceChange();
              that.$nextTick(() => {
                form.SelectedCity = tempCompanyExhibit.shippingPortCity;
              })

              //产品型号
              form.modelNum = tempCompanyExhibit.modelNum;
              //产能
              form.AbilityNumber = tempCompanyExhibit.abilityNumber;
              //产能 单位
              form.SupplyUnit = tempCompanyExhibit.abilityUnit;
              if (form.SupplyUnit === 99) {
                //产能 单位
                form.SupplyUnitOther = tempCompanyExhibit.abilityUnitOther;
              }
              //产能 时间计算
              form.SupplyTime = tempCompanyExhibit.abilityPeriod;
              //最小起订量
              form.MoqNumber = tempCompanyExhibit.moqNumber;
              //最小起订量 单位
              form.MoqSupplyUnit = tempCompanyExhibit.moqUnit;
              if (form.MoqSupplyUnit === 99) {
                //产能 单位
                form.MoqSupplyUnitOther = tempCompanyExhibit.moqUnitOther;
              }
              //应用行业
              var tempExhibitIndustrys = data.tempExhibitIndustrys;
              if (tempExhibitIndustrys.length > 0) {
                var applicationIndustries = [];
                tempExhibitIndustrys.forEach((element) => {
                  applicationIndustries.push("" + element.industryId + "");
                });
                form.applicationIndustries = applicationIndustries;
              }
              this.form.TempExhibitCats = data.tempExhibitCats;
              //产品类别
              var tempExhibitCats = data.tempExhibitCats;
              if (tempExhibitCats.length > 0) {
                var productCats = [];
                tempExhibitCats.forEach((element) => {
                  productCats.push("" + element.subId + "");
                });
                form.productCats = productCats;
              }

              //热搜标签
              var tempExhibitTags = data.tempExhibitTags;
              if (tempExhibitTags.length > 0) {
                var productTags = [];
                tempExhibitTags.forEach((element) => {
                  productTags.push(element.tagId);
                });
                form.selectedHotSearchTags = productTags;
              }

              //关键字
              var tempExhibitKeywords = data.tempExhibitKeywords;
              if (tempExhibitKeywords.length > 0) {
                form.keywordList = tempExhibitKeywords.filter(x => x.langId != 936).sort(
                  function (a, b) {
                    var o1 = a.langId;
                    var o2 = b.langId;
                    var p1 = a.orderId;
                    var p2 = b.orderId;
                    if (p1 < p2) return -1;
                    if (p1 > p2) return 1;
                    if (o1 < o2) return 1;
                    if (o1 > o2) return -1;
                    return 0
                  }
                );
              }
              //图片，视频
              let shortVideoItem = {
                modified: false,
                videoId: null,
                videoSrc: null,
                videoCdnLnk: null,
                imageSrc: null,
                imgCdnLnk: null,
              }
              var files = data.files;
              if (files.length > 0) {
                const filesMap = {};
                files.forEach((element) => {
                  filesMap[element.usageType] = element;
                });
                files.forEach((element) => {
                  filesMap[element.usageType] = element;
                  if (element.fileName) {
                    if (element.usageType == "ExhibitPhoto") {
                      var Arr = {
                        imageId: element.rid,
                        imageSrc: element.fileName,
                        modified: false,
                        cdnLnk: element.fileName,
                      };
                      form.imgArr.push(Arr);
                    }
                    if (element.usageType === "ExhibitVideo") {
                      form.video = {
                        videoId: element.rid,
                        videoSrc: element.fileName,
                        videoCdnLnk: element.fileName,
                      };
                    }
                    if (element.usageType == "ExhibitVideo_Cover") {
                      form.video_cover = {
                        imageSrc: element.fileName,
                        imgCdnLnk: element.fileName,
                      };
                    }
                    if (element.usageType === "ExhibitVideo_Short") {
                      shortVideoItem.videoId = element.rid
                      shortVideoItem.videoSrc = element.fileName
                      shortVideoItem.videoCdnLnk = element.fileName
                      
                    }
                    if (element.usageType == "ExhibitVideo_Short_Cover") {
                      shortVideoItem.imageSrc = element.fileName
                      shortVideoItem.imgCdnLnk = element.fileName
                      
                    }
                  }
                });
                var vArr = {
                  modified: false,
                  videoId: form.video.videoId,
                  videoSrc: form.video.videoSrc,
                  videoCdnLnk: form.video.videoCdnLnk,
                  imageSrc: form.video_cover.imageSrc,
                  imgCdnLnk: form.video_cover.imgCdnLnk,
                };
                if (form.video.videoSrc) {
                  form.videoArr.push(vArr);
                }
                if(shortVideoItem.videoSrc){
                  form.shortVideoArr.push(shortVideoItem)
                }
                form.files.forEach((el) => {
                  const matchedFile = filesMap[el.usageType];
                  if (matchedFile) {
                    // 检查是否存在匹配的文件
                    el.EmpCompanyId = matchedFile.empCompanyId;
                    el.UsageType = matchedFile.UsageType;
                    el.FileName = matchedFile.FileName;
                    el.EmpProductID = matchedFile.EmpProductID;
                    el.OrderID = matchedFile.OrderID;
                  }
                });
              }
            }
          })
          .finally(() => {
            that.loading = false;
            setTimeout(() => {
              that.dirty = false;
            }, 500);
          });
        setTimeout(() => {
          var parms = { type: "Product", id: form.productId };
          productService.GetOtherInfo(parms).then((res) => {
            if (res.isSuccessful && res.statusCode == 200) {
              that.lastSubmitDate = res.data["lastSubmitDate"];
              that.lastThreeMonthSubmitCount = res.data["lastThreeMonthSubmitCount"];
            }
            // 更新原始的data对象
            this.originalData = JSON.parse(JSON.stringify(this.$data.form));
          });
        }, 500);
      } else {
        setTimeout(() => {
          that.dirty = false;
        }, 500);
        that.loading = false;
      }
    },
    /**
     * 添加关键字
     */
    addKeyword() {
      //console.log(this.form.productId);
      // if (this.form.txtkeywordListEng.length < this.keywordLimit) {
      //   this.form.txtkeywordListEng.push("");
      //   this.form.txtkeywordListChi.push("");
      // }
      if (this.form.keywordList.length < this.keywordLimit) {
        var keyword = Object.assign({}, this.form.keyword);
        var num =
          this.form.keywordList.length > 1
            ? this.form.keywordList.length / 2
            : this.form.keywordList.length;
        num = num + 1;
        keyword.productId = this.form.productId;
        keyword.orderId = num;
        keyword.langId = 1252;
        // console.log(keyword)
        this.form.keywordList.push(keyword);
        // console.log(this.form.keywordList)

        var keyword = Object.assign({}, this.form.keyword);
        keyword.productId = this.form.productId;
        keyword.orderId = num;
        keyword.langId = 950;
        // console.log(keyword)
        this.form.keywordList.push(keyword);
        // console.log(this.form.keywordList)
      }
    },
    /**
     * 删除关键字
     */
    removeKeyword(index) {
      // console.log(this.form.keywordList)
      // console.log(index)
      this.$delete(this.form.keywordList, index);
      this.$delete(this.form.keywordList, index - 1);
    },
    handleSelectionChange(val) {
      //console.log("productCatschage");
      //console.log(val);
    },
    async Delete() {
      var that = this;
      var valid = await productService.CheckProductBeforeDelete({
        productid: this.form.productId
      }).then((res) => {
        if (res.isSuccessful) {
          return true
        } else {
          var message = that.$t("lbl_EMPBE_DeleteFailed");
          var messageCode = res.data;
          if (messageCode == 'LinkedAd') {
            message = that.$t("lbl_EMPBE_ProductDeleteCheck_LinkedAd")
          }
          that.alertMsg(message);
          return false;
        }
      })
      if (!valid) return false;
      var result = await productService
        .deleteCompanyExhibitDetails({
          companyId: this.form.empCompanyId,
          ProductId: this.form.productId,
        })
        .then((res) => {
          if (res.isSuccessful) {
            //console.log(res);
            var message = that.$t("lbl_EMPBE_DeleteSuccess");
            that.alertMsg(message);
            // this .$router.push({ path:'/productInfoCenter/default', query:{ refresh:true } });
            // this.$parent.refresh();
            //this .$router.push({ path:'/productInfoCenter/default'});
            return true;
          } else {
            var message = that.$t("lbl_EMPBE_DeleteFailed");
            that.alertMsg(message);
            return false;
          }
        });
      return result;
    },
    /**
     * 组装提交 数据
     */
    async GetParam() {
      var that = this;
      var form = this.form;
      var tempCompanyExhibit = {
        ProductId: form.productId,
        EmpCompanyId: form.empCompanyId,
        ExhibitNameE: form.productnameEng,
        ExhibitNameS: form.productnameChi,
        ExhibitNameT: form.productnameChi,
        SeqId: form.seqId,
        ShippingPortCountry: form.SelectedCountry,
        ShippingPortCity: form.SelectedCity,
        ShippingPortProvince: form.SelectedProvince,
        ShippingPortRegion: "",
        DescS: form.productDescChi,
        DescE: form.productDescEng,
        DescT: form.productDescChi,
        IsDisplayInShow: form.IsDisplayInShow,
        IsProvideFreeSample: form.IsProvideFreeSample,
        AbilityNumber: form.AbilityNumber,
        AbilityPeriod: form.SupplyTime,
        AbilityUnit: form.SupplyUnit,
        AbilityUnitOther: form.SupplyUnitOther,
        PremiereDate: form.NewProdPostDate,
        IsLaunch: form.isLaunch,
        IsMainProduct: form.isMainProduct,
        IsNewProduct: form.isNewProduct,
        IsNewTech: form.isNew,
        ModelNum: form.modelNum,
        MoqNumber: form.MoqNumber,
        MoqUnit: form.MoqSupplyUnit,
        MoqUnitOther: form.MoqSupplyUnitOther,
        NewTech: form.newTech,
        ShippingPortCityCn: form.PortCityChi,
        ShippingPortCityEn: form.PortCityEng,
      };
      //console.log(tempCompanyExhibit);

      
      //产品类别
      var TempExhibitCats = form.TempExhibitCats;

      //应用行业
      var TempExhibitIndustrys = [];
      form.applicationIndustries.forEach((element, index) => {
        var TempExhibitIndustry = {
          ProductId: this.form.productId,
          IndustryId: element,
          OrderId: index + 1,
        };
        TempExhibitIndustrys.push(TempExhibitIndustry);
      });
      //热搜标签
      var TempExhibitTags = [];
      if (form.selectedHotSearchTags) {
        form.selectedHotSearchTags.forEach((element, index) => {
          var TempExhibitTag = {
            ProductId: this.form.productId,
            TagId: element,
            OrderId: index + 1,
          };
          TempExhibitTags.push(TempExhibitTag);
        });
      }
      
      //关键字
      var TempExhibitKeywords = this.form.keywordList;

      if (this.$refs.ExhibitPhoto) {
        if (this.$refs.ExhibitPhoto.$children.length > 0) {
          this.$refs.ExhibitPhoto.AppendUploadQuery();
        }
      }

      if (this.$refs.ExhibitVideo) {
        if (this.$refs.ExhibitVideo.$children.length > 0) {
          this.$refs.ExhibitVideo.AppendUploadQuery();
        }
      }
      if(this.$refs.ExhibitVideo_Short){
        if(this.$refs.ExhibitVideo_Short.$children.length > 0){
          this.$refs.ExhibitVideo_Short.AppendUploadQuery();
        }
      }
      var filesdata = [];
      var photoOrderId = 0;
      await fileUploadService.UploadToServer(this).then((res) => {
        // console.log(res);
        if (res == undefined) {
          this.$swal({
            //Show Alert
            text: this.$t("lbl_EMPBE_UploadFailed"),
            showCancelButton: false,
            confirmButtonText: this.$t("lbl_EMPBE_Confirm"),
            cancelButtonText: this.$t("lbl_EMPBE_Cancel"),
          })
        }
        //console.log(res)

        var arr = res;
        var cdnLnk = "";
        if (arr.length > 0) {
          arr.forEach((el) => {
            var fileType = el.refName;
            switch (el.type) {
              case "Image":
                el.array.forEach((element) => {
                  photoOrderId = photoOrderId + 1;
                  cdnLnk = element.cdnLnk;
                  if (cdnLnk) {
                    var _item = {
                      EmpCompanyId: that.form.empCompanyId,
                      EmpProductId: that.form.productId,
                      FileName: cdnLnk,
                      OrderId: photoOrderId,
                      UsageType: fileType,
                    };
                    filesdata.push(_item);
                  }
                });
                break;
              case "Video":
                el.array.forEach((element) => {
                  var imgCdnLnk = element.imgCdnLnk;
                  if (imgCdnLnk) {
                    var video_cover = {
                      EmpCompanyId: that.form.empCompanyId,
                      EmpProductId: that.form.productId,
                      FileName: imgCdnLnk,
                      OrderId: 1,
                      UsageType: fileType + "_Cover",
                    };
                    filesdata.push(video_cover);
                  }
                  var videocdnLnk = element.videoCdnLnk;
                  if (videocdnLnk) {
                    var video = {
                      EmpCompanyId: that.form.empCompanyId,
                      EmpProductId: that.form.productId,
                      FileName: videocdnLnk,
                      OrderId: 1,
                      UsageType: fileType,
                    };
                    filesdata.push(video);
                  }
                });
                break;
              default:
                break;
            }
          });
        }
        return filesdata;
      });

      that.form.files = filesdata;
      //console.log("that.form.files");
      //console.log(that.form.files);

      var parms = {
        TempCompanyExhibit: tempCompanyExhibit, //产品详情
        TempExhibitTags: TempExhibitTags, //热搜标签
        TempExhibitKeywords: TempExhibitKeywords, //关键字
        Files: that.form.files, //文件（图片，视频，视频截图）
        TempExhibitCats: TempExhibitCats, //产品类别
        TempExhibitIndustrys: TempExhibitIndustrys, //应用行业
        ProductPriceCurrUnit: that.form.price.ProductPriceCurrUnit,
        ProductPriceAmount: that.form.price.ProductPriceAmount,
        ProductPriceAmountMax: that.form.price.ProductPriceAmountMax,
        ProductPriceDisplay: that.form.price.ProductPriceDisplay,
        ProductPriceItemUnit: that.form.price.ProductPriceItemUnit,
        ProductPriceRange: that.form.price.ProductPriceRange,
        ProductPriceItemUnitOther: that.form.price.ProductPriceItemUnitOther
      };
      //console.log(parms);
      return parms;
    },
    async todoSave() {
      let that = this;
      that.loading = true;
      var Params = await this.GetParam();
      //console.log(Params);
      productService
        .saveProdutAsync(Params)
        .then((res) => {
          if (res.isSuccessful) {
            var message = that.$t("lbl_EMPBE_SaveSuccess");
            that.alertMsg(message);
            if (that.form.productId != res.data) {
              that.$router.push({
                name: that.$router.currentRoute.name,
                params: { id: res.data },
              });
              that.$parent.$parent.$parent.$parent.openSidebarAfterSave();
            }
            that.refreshParent();
            that.refresh();
          }
        })
        .finally(() => {
          that.loading = false;
        });
    },
    async todoSubmit() {
      let that = this;
      var Params = await this.GetParam();
      // console.log(Params);
      that.loading = true;
      productService
        .submitProdutAsync(Params)
        .then((res) => {
          if (res.isSuccessful) {
            var message = that.$t("lbl_EMPBE_CompanySubmitSuccess");
            that.alertMsg(message);
            if (that.form.productId != res.data) {
              that.$router.push({
                name: that.$router.currentRoute.name,
                params: { id: res.data },
              });
              // that.$parent.$parent.$parent.$parent.openSidebarAfterSave();
            }
            that.refreshParent();
            that.refresh();
            that.$parent.$parent.$parent.$parent.hideSidebarNavMenu();
          } else {
            var textStr =
              "<div style=' color: red;'>" +
              that.$t("lbl_EMPBE_SubmitFailWithReason") +
              "</div>";
            textStr = textStr + "<ul style='text-align: left;'>";
            res.systemErrorMsg.forEach((el) => {
              textStr = textStr + "<li>" + el + "</li>";
            });
            textStr = textStr + "</ul>";
            that.$swal({
              html: textStr,
              showCancelButton: false,
              confirmButtonText: this.$t("lbl_EMPBE_Confirm"),
              cancelButtonText: this.$t("lbl_EMPBE_Cancel"),
            });
          }
        })
        .finally(() => {
          that.loading = false;
        });
    },
    checkProductLaunch() {
      let that = this;
      // var otherInfo = this.$parent.$parent.$parent.$parent.getotherInfo();
      // var launchCount = this.$route.params.id > 0 ? otherInfo.product_LaunchedCount : otherInfo.product_LaunchedCount + 1
      if (false) { //launchCount > otherInfo.product_TotalQty //[19112024][SJP] fix unable to edit bug when the product count is full
        var message = that.$t("lbl_EMPBE_OverActivateProdAmount");
        that.alertMsg(message);
      } else {
        //保存和提交操作
        if (that.IsSave) {
          this.todoSave();
        }
        if (that.IsSubmit) {
          this.todoSubmit();
        }
      }
      // var result = productService
      //   .checkSysAccountPaymentInfo({
      //     CompanyId: this.companyid,
      //     type: "product",
      //     id: this.form.productId,
      //     demodate: "",
      //   })
      //   .then((res) => {
      //     if (res.isSuccessful) {
      //       if (res.data) {
      //         let data = res.data;
      //         if (data.launchCount > data.payTotalQty) {
      //           var message = that.$t("lbl_EMPBE_OverActivateProdAmount");
      //           that.alertMsg(message);
      //           return false;
      //         } else {
      //           //保存和提交操作
      //           if (that.IsSave) {
      //             this.todoSave();
      //           }
      //           if (that.IsSubmit) {
      //             this.todoSubmit();
      //           }
      //         }
      //       } else {
      //         //保存和提交操作
      //         if (that.IsSave) {
      //           this.todoSave();
      //         }
      //         if (that.IsSubmit) {
      //           this.todoSubmit();
      //         }
      //       }
      //     }
      //   });
      // return result;
    },
    // async GetProductMainProdCount() {
    //   var that = this;
    //   var result = await productService.GetProductMainProdCount({ CompanyId: this.companyid, productId: this.form.productId });
    //   if (result.isSuccessful && that.permissionData !=null) {
    //     if (result.data + 1 <= that.permissionData.MaxMainProdAmount) {
    //       return true;
    //     }
    //   }
    //   var message = that.$t('lbl_EMPBE_OverMainProdAmount');
    //   that.alertMsg(message);
    //   return false;
    // },
    async GetProductMainProdCount() {
      var that = this;
      return productService
        .GetProductMainProdCount({ CompanyId: this.companyid, productId: that.form.productId })
        .then((result) => {
          if (result.isSuccessful && that.permissionData != null) {
            if (result.data + 1 <= that.permissionData.MaxMainProdAmount) {
              return true;
            }
          }
          var message = that.$t("lbl_EMPBE_OverMainProdAmount");
          that.alertMsg(message);
          return false;
        });
    },
    alertMsg(message) {
      this.$swal({
        html: message,
        showCancelButton: false,
      });
    },
    showRequiredFieldAlert() {
      //[20240118][JWS] add required field alert
      this.$swal({
        html: this.$t("lbl_EMPBE_CompanySubmitFailRequiredField"),
        showCancelButton: false,
        confirmButtonText: this.$t("lbl_EMPBE_Confirm"),
        cancelButtonText: this.$t("lbl_EMPBE_Cancel"),
      })
    },
    async GetQRCode() {
      // CompanyInfoService.GetCompanyQRCode({companyId : this.form.empCompanyId, seqId: this.form.productId, RegSource: "-1"}).then((res) =>{
      //   if(res.isSuccessful){
      //     this.IsPending = (!res.data.fileName || res.data.fileName == "Pending")
      //     if (this.IsPending && this.FetchQRCodeTime < this.ReFetchLimit) {

      //         this.FetchQRCodeTime++
      //         //If the qrcode is generating -> refetch (Usually occur in the first time of getting qr code)
      //         setTimeout(() => {
      //           this.GetQRCode();
      //         }, 2000);

      //     }
      //     else if (!this.IsPending) {
      //       this.QRCodeOSSURL = res.data.fileName;
      //     }



      //   }
      // })
    },
    MapProvinceDataToOptions(){
      this.resProv.forEach((item) => {
          var _item = {
            id: item.provCode,
            label: item.provName,
          };
          this.options_province.push(_item);
        });
    },
    MappCityDataToOptions(){
      var c = this.city.filter((x) => x.prov_Code == this.form.SelectedProvince);
      this.options_city = [];
      c.forEach((item) => {
        var _item = {
          id: item.city_id,
          label: item.city_Name,
        };
        this.options_city.push(_item);
      });

      return c

    }
  },
};
</script>
<style scoped>
b-button {
  contain: paint;
}
.NewsTips
    {
      padding: 4px 6px;
      align-items: center;
      gap: 2px;
      border-radius: 25px;
      background: var(--Warning, #FFD02C);
      overflow: hidden;
      color: var(--on-surface-80, rgba(0, 0, 0, 0.80));
      text-align: center;
      text-overflow: ellipsis;
      font-size: 12px;
      font-style: normal;
      font-weight: 600;
      line-height: 150%; /* 18px */
      letter-spacing: -0.132px;
    }
</style>
